<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="confirmdelete" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Route Type</button>
						<button [disabled]="IsLoading() == true || CanEdit() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">
							Edit Route Type
						</button>
						<button [disabled]="IsLoading() == true || CanDelete() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onToggle()">
							{{ ToggleText }}
						</button>
						<button [disabled]="IsLoading() == true || CanDelete() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">
							Delete Route Type
						</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstRouteType"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedRouteType"
						dataKey="BusRouteTypeID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--RouteTypeCD-->
								<th>
									<p-columnFilter type="text" field="BusRouteTypeNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--RouteTypeDesc-->
								<th>
									<p-columnFilter type="text" field="BusRouteTypeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--DefinedBy-->
								<th>
									<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterDefinedByDesc
												[ngModel]="value"
												[options]="lstDefinedByDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ActiveDesc-->
								<th>
									<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterActiveDesc
												[ngModel]="value"
												[options]="lstActiveDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="BusRouteTypeNbr">Number<p-sortIcon field="BusRouteTypeNbr"></p-sortIcon></th>
								<th pSortableColumn="BusRouteTypeDesc">Description<p-sortIcon field="BusRouteTypeDesc"></p-sortIcon></th>
								<th pSortableColumn="DefinedByID">Defined By<p-sortIcon field="DefinedByID"></p-sortIcon></th>
								<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-RouteType>
							<tr [pSelectableRow]="RouteType" (dblclick)="onRowDblClick(RouteType)">
								<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
									{{ RouteType[col.field] }}
								</td>

								<td
									style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
									[style.color]="RouteType.DefinedByID <= 2 ? 'Blue' : 'Black'"
								>
									{{ RouteType["BusRouteTypeDesc"] }}
								</td>

								<td
									style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
									[style.color]="RouteType.DefinedByID > 2 ? 'Black' : 'Red'"
								>
									{{ RouteType["DefinedByDesc"] }}
								</td>

								<td
									style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
									[style.color]="RouteType.Active == true ? 'Black' : 'Red'"
								>
									{{ RouteType["ActiveDesc"] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
